export const ROUTES = {
  EVENT_SEARCH: 'eventSearch',
  EVENT: 'event',
  TESTING: 'testing',
  RESULTS: 'results',
  SLUG: 'e',
  REQUEST_PASSWORD_RESET: 'request-password-reset',
}
